import Enum from './enum'

class UserState extends Enum
{
  constructor(value) {
    super(value);
  }
}

UserState.init({
  ACTIVE: 'Active',
  APPROVED: 'Approved',
  UNAUTHORIZED: 'Unauthorized',
  BLOCKED: 'Blocked',
  ARCHIVED: 'Archived'
}, {
  UNAUTHORIZED: 'user-state.unauthorized',
  ACTIVE: 'user-state.active',
  APPROVED: 'user-state.approved',
  BLOCKED: 'user-state.blocked',
  ARCHIVED: 'user-state.archived'
});

export default UserState;
